
import React, { useEffect, useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { FormWrapperInputComponent } from '../../../../common/component/Index'
import Wrapper from '../../../../common/component/Wrapper'
import { Descriptions, Input, Modal, Table, List, Button, message, Switch } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import './UpdateStatusGroup.less'

const { Item } = Descriptions

const UpdateStatusGroup = (props) => {
    const {
        show,
        handleOk,
        handleCancel,
        t,
        promotionState,
        handleUpdateStatusGroup,
        getSampleFileStatus
    } = props

    const {
        isFetchingDataStatusGroup,
        dataStatusGroup
    } = promotionState

    let sameKeyCampaign;
    let sameKeyBundle;

    const [data, setData] = useState([])
    const [reason, setReason] = useState('')
    const [status, setStatus] = useState(true)
    const [fileName, setFileName] = useState('')

    const uploadInput = useRef(null);

    useEffect(() => {
        parseData(dataStatusGroup)
    }, [dataStatusGroup])

    const showUpload = () => {
        uploadInput.current.click()
    }

    const onFileChange = (e) => {
        if(!!e.target.files.length) {
            setFileName(e.target.files[0].name)
            props.importStatusGroup(e.target.files[0])
        }
    }

    const parseData = (dataGroup) => {
        const arrCampaign = []
        if (dataGroup && !!dataGroup.data.length) {
            dataGroup.data.forEach(campaign => {
                campaign.codes.forEach(code => {
                    arrCampaign.push({
                        ...code,
                        bundleName: campaign.bundle,
                        campaignName: campaign.campaign,
                        bundleId: campaign.bundleId,
                        key: code.id,
                        id: code.id
                    })
                })
            })
            setData(arrCampaign)
        }
    }

    const columns = [
        {
            title: "Tên chiến dịch",
            dataIndex: "campaignName",
            key: "campaignName",
            render: (value, row, index) => {
                const obj = {
                    children: value,
                    props: {}
                };
                if (!(sameKeyCampaign !== row.bundleId)) {
                    obj.props.rowSpan = 0;
                    return obj;
                }
                const count = data.filter(item => item.bundleId === row.bundleId).length;
                sameKeyCampaign = row.bundleId;
                obj.props.rowSpan = count;
                return obj;
            }
        },
        {
            title: "Tên Bundle",
            dataIndex: "bundleName",
            key: "bundleName",
            render: (value, row, index) => {
                const obj = {
                    children: value,
                    props: {}
                };
                if (!(sameKeyBundle !== row.bundleId)) {
                    obj.props.rowSpan = 0;
                    return obj;
                }
                const count = data.filter(item => item.bundleId === row.bundleId).length;
                sameKeyBundle = row.bundleId;
                obj.props.rowSpan = count;
                return obj;
            }
        },
        {
            title: "Code",
            dataIndex: "code",
            key: "code",
            render: (value, row, index) => {
                return value
            }
        },
    ];

    const submitChange = () => {
        if(!reason || (!data.length)) {
            return message.error('Vui lòng kiểm tra lại giữ liệu')
        }
        const uuidCode = data.map(code => code.id)
        const statusGroupCode = {
            reason,
            active: status,
            guids: uuidCode
        }
        handleUpdateStatusGroup(statusGroupCode)
        handleOk()
    }

    const handleDownload = () => {
        getSampleFileStatus()
    }

    const handleClose = () => {
        handleCancel()
    }

    return (
        <Modal
            title={t(`item.promotions.titleImportExcel`)}
            width={1000}
            visible={show}
            onCancel={handleClose}
            footer={[
                <Button 
                    key="submit" 
                    type="primary" 
                    loading={isFetchingDataStatusGroup} 
                    onClick={submitChange}
                    disabled={!data.length || !reason}
                >
                    {t('action.updateStatus')}
                </Button>
            ]}
        >
            <div className="row m-b">
                <Wrapper className="col-md-8">
                    <FormWrapperInputComponent
                        labelTitle={t(`item.promotions.uploadDocument`)}
                    >
                        <div className="row">
                            <div className="col-md-7">
                                <Input 
                                    readOnly 
                                    placeholder={t('item.promotions.inputTypePlaceholder')}
                                    type={`text`} 
                                    value={fileName} 
                                    className="cursor-pointer"
                                    onClick={showUpload} />
                                <input ref={uploadInput} className="input-upload" type="file" onChange={onFileChange} />
                            </div>
                            <div className="col-md-5">
                                <Button type="primary" onClick={showUpload} className="m-r">
                                    {t('action.import')}
                                </Button>
                                <Button type="primary" onClick={handleDownload}>
                                    {t('action.exportFileSample')}
                                </Button>
                            </div>
                        </div>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-4">
                    <FormWrapperInputComponent
                        labelTitle={t(`item.promotions.status`)}
                    >
                        <div>
                            <Switch 
                                checkedChildren={t(`item.promotions.active`)} 
                                unCheckedChildren={t(`item.promotions.deactive`)} 
                                defaultChecked onChange={() => setStatus(!status)} 
                                />
                        </div>
                    </FormWrapperInputComponent>
                </Wrapper>
            </div>
            <Table
                className="m-b"
                columns={columns}
                dataSource={data}
                bordered
                pagination={false}
                scroll={{ y: 250 }}
            />
            <div className="row">
                <Wrapper className="col-md-8">
                    <FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        labelTitle={t(`item.promotions.reason`)}
                    >
                        <TextArea
                            className="form-control" name="shortDescription" onChange={(e) => setReason(e.target.value)}
                            value={reason} />
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-4">
                    <FormWrapperInputComponent
                        labelTitle={t(`item.promotions.invalidCode`)}
                    >
                        <List
                            size="small"
                            className="list-code"
                            bordered
                            dataSource={dataStatusGroup?.invalidCodes}
                            renderItem={code => <List.Item>{code}</List.Item>}
                        />  
                    </FormWrapperInputComponent>
                </Wrapper>
            </div>
        </Modal>
    )
}

export default withTranslation()(UpdateStatusGroup)